export default __webpack_public_path__ + "build/static/media/fire.343a8de3.svg";